<template>
  <div class="homeht">
    <div class="hometop">
      <div class="toptxt homecen">
        <h4 style="margin-left: 40px; text-align: left">个股研究</h4>
        <p style="margin-left: 40px">估值视角，研判股票价格</p>
        <div class="cenhover" style="position:relative">
          <!-- <div  class="pdf" @click="showPdf()"><img src="https://wh-api.wenhua.com.cn/api/WhBanner/GetWhBannerUrl?id=115" alt=""></div> -->
          <div
            v-for="(item1, index1) in bak1"
            :key="index1"
            class="topkua"
            @click="goto1(index1)"
          >
            <img :src="bak1[index1]" alt="" />
            <h4>{{ tit1[index1] }}</h4>
            <!-- <p>{{ bg1[index1] }}</p> -->
            <p>{{ txt1[index1] }}</p>
            <!-- <div @click="goto(index)" class="xiangqing">查看详情></div> -->
          </div>
        </div>
      </div>
    </div>
    <div class="toptxt" style="padding-top: 50px">
      <h4 style="margin-left: 40px; text-align: left">股票池研究</h4>
      <p style="margin-left: 40px">
        研判入场时机，优化投资组合
      </p>
      <div class="cenhover">
        <div
          v-for="(item, index) in bak2"
          :key="index"
          class="topkua"
          @click="goto2(index)"
        >
          <img :src="bak2[index]" alt="" />
          <h4 v-if="index != 'cen9'">{{ tit2[index] }}</h4>
          <h4 v-if="index == 'cen9'">
            T<span style="position: relative; left: -4px">+</span
            ><span style="position: relative; left: -6px">0</span>持仓列表
          </h4>
          <!-- <p>{{ bg2[index] }}</p> -->
          <p>{{ txt2[index] }}</p>
          <!-- <div @click="goto(index)" class="xiangqing">查看详情></div> -->
        </div>
      </div>
    </div>
    <div class="homebo">
      <div class="botxt">
        <h5><common-data name="appShortName_26" v-common-display/><common-data name="appFullName_26" v-common-display/></h5>
        <!-- <p>文华财经旗下的证券T+0交易软件，面向专业投资者。</p> -->
        <p>
          面向专业投资者，基于财务分析，提供多因子估值图表，利润滤镜、风险甄别、EVA分析等风险研究工具...
        </p>
        <!-- <router-link
          to="/news"
          style="display: inline-block; padding-top: 15px"
          class="link"
          target="_blank"
          >媒体报道</router-link
        > -->
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  data() {
    return {
      bak1: {
        cen5: [require("../../assets/img/newimgdj.png")],
        // cen9: [require("../../assets/img/股息率投资方法.png")],
        // cen10: [],
        // cen11: [],
        // cen1: [require("../../assets/img/newimgcw.png")],
        cen2: [require("../../assets/img/newimglr.png")],
        cen3: [require("../../assets/img/newimgfx.png")],
        // cen4: [require("../../assets/img/newimgeva.png")],
        // cen6: [require("../../assets/img/newimgjbm.png")],
        // cen7: [require("../../assets/img/hgfxgj.png")],
        // cen8: [require("../../assets/img/hyfxgj.png")],
      },
      tit1: {
        cen1: "财务画像",
        cen2: "小文财报",
        cen3: "风险甄别",
        // cen4: "EVA分析",
        cen5: "小文估值",
        cen6: "基本面选股",
        cen7: "宏观分析工具",
        cen8: "行业分析工具",
        cen9: "股息率统计",
      },
      bg1: {
        cen1: "【开发背景】非财务背景的投资者，阅读财务报表存在障碍，即使通读财报有时候也难以清晰认知企业。",
        cen2: "【开发背景】企业粉饰财务报表主要是在会计准则允许的范围内调节资产负债表和利润表数据。",
        cen3: "【开发背景】有些投资者选股时只关心净利润，却忽视了现金流。但相对于利润的“纸上富贵”，现金流才是企业“真金白银”。",
        cen4: "【开发背景】传统会计利润不考虑公司股东的投入成本，就难以发掘到公司利润为正但却未真正实现价值增长的情况。",
        cen5: "【开发背景】外来的DCF、DDM等估值算法不适合中国股市，市场上缺乏实用性的价格研究工具。",
        cen6: "【开发背景】技术指标更多注重的是价格，很少关注公司的内在价值，在大盘表现不好时选股结果往往不尽如人意。",
        cen7: "【开发背景】经济衰退时期投资股票，在经济复苏时却持有大量现金，这种错配是由于没有做到与经济周期同步。",
        cen8: "【开发背景】投资者可接触到的信息往往是对宏观经济大形势的分析，但投资真正需要的是哪一些行业值得投资。",
        cen9: "【开发背景】传统股息率算法以自然年为周期，以当前股价作为基准计算，不能客观表征投资者的真实股息收益水平。",
      },
      txt1: {
        cen1: "基于企业经营活动逻辑，对企业的资产、负债、收益和现金流进行重构，直观展示企业的利润来源、盈利能力等，刻画了企业的真实财务画像，助投资者看懂财务数据。",
        cen2: "借助AI大模型技术，小文财报以财务数据的季度边际变化为核心，聚焦影响股价的关键财务变量，精准识别盈利能力改善、现金流波动、资产结构调整等经营情况变化的拐点信号。",
        cen3: "直面现金流和利润间的差异，揭示企业经营过程中是否存在异常，助投资者提前规避投资风险。",
        cen4: "综合考虑股权和债权成本，能更准确地体现公司经营状况以及真正能给予股东的价值回报，助投资者进一步考量公司的价值创造能力。",
        cen5: "借助AI大模型技术，原创的多因子估值算法，用上市公司的利润、资产、市场流动性、市场情绪等多元数据来构建估值体系，绘制在k线图上表现为股票的价值线、支撑线、阻力线。",
        cen6: "从页面统计中发掘行业指标标准，用基本面选股选出各行业内竞争力强、适合长期持有的优质股票。",
        cen7: "通过科学的经济数据计算，为寻找经济传导逻辑、优化行业投资组合提供分析基础。",
        cen8: "深入解析行业之间及行业内部的情况，判定行业生命周期，挖掘最具投资潜力的行业。",
        cen9: "原创的财年股息率算法，以上市公司年度分红除权日为起点划分“财年”，计算股息率和资产增值率，开创股息率投资方法。",
      },
      bak2: {
        // cen6: [require("../../assets/img/sjxd1.png")],
        // // cen7: [require("../../assets/img/sdcd.png")],
        // // cen8: [require("../../assets/img/wgcl.png")],
        // cen9: [require("../../assets/img/dlcc.png")],
        // cen4: [require("../../assets/img/wjxd.png")],
        // cen5: [require("../../assets/img/sfcd.png")],
        cen3: [require("../../assets/img/lsfx.png")],
        cen10:[require("../../assets/img/对比分析.png")],
      },
      tit2: {
        cen6: "三键下单工具",
        // cen7: "盘口炒单工具",
        // cen8: "网格策略工具",
        cen9: "T+0独立持仓列表",
        // cen4: "文件下单",
        // cen5: "分批下单",
        cen10: "评分排名",
        cen3: "综合k线",
      },
      bg2: {
        cen6: "【开发背景】传统的证券下单工具，完成一次交易需要点击多个按钮，操作略显繁琐，无法满足T+0交易者对下单速度的要求。",
        cen7: "【开发背景】根据盘口报价挂单交易时，普通下单工具需要频繁使用键盘或鼠标调整委托价格，费时、费力。",
        // cen8: "【开发背景】网格策略是一种在震荡行情中获利的交易手法，手动进行网格策略交易操作繁琐，效率不高。",
        cen9: "【开发背景】传统的持仓列表将隔夜持仓和当日持仓合并显示，T+0交易者无法获知日内持仓信息，缺少平仓分析依据。",
        cen4: "【开发背景】机构投资需要一次交易一篮子股票，需要专用的交易工具。",
        cen5: "【开发背景】如果一次下单的手数过大，会带来冲击成本，交易员手动分批下单又费时费力。",
        cen10: "【开发背景】筛选好企业只看技术指标是远远不够的，还要看企业的经营状况和综合竞争力。",
        cen3: "【开发背景】投资一只股票可以看k线图趋势判断入场时机，但是机构一次投资一篮子股票却没有一个直观的分析工具。",
      },
      txt2: {
        cen6: "三键下单工具可一键买入/卖出开仓，并由电脑自动判断平仓交易方向，简化思考逻辑，实现买入/卖出使用同一平仓按钮一键平仓。",
        cen7: "提供可视化交易界面，独立展示盘口报价，点击报价直接进行挂单交易，简化交易过程；账户挂单、持仓情况一目了然，有效掌控全局。",
        // cen8: "软件内置网格策略工具，只需填写相关参数，即可自动高抛低吸，循环执行，且可同时进行多个网格策略交易。",
        cen9: "T+0持仓列表独立计算日内交易持仓数据，展示日内交易的持仓方向、开仓均价、浮动盈亏等数据。", //，且提供交易统计数据，方便查看日内交易盈亏
        cen4: "文件下单功能自动扫描Excel文件发送委托，将文件中安排好的交易指令高效的转化为账户持仓，还内置算法，可以实现算法拆单。",
        cen5: "分批下单工具内置多种算法，通过调整参数，即可进行智能拆单，帮助机构提高交易效率，降低冲击成本。",
        cen10: "从市场表现、经营能力、偿债能力等多方面，对自选股进行综合评分，筛选出竞争力强的优质股票，构建投资组合。",
        cen3: "提供一篮子股票的综合K线，用投资一只股票一样的逻辑来做价格百分位分析，研判一篮子股票投资时机。",
      },
      go1: {
        cen1: "2",
        cen2: "1",
        cen3: "4",
        cen4: "5",
        cen5: "0",
        cen6: "6",
        cen7: "8",
        cen8: "9",
        cen9: "1",
      },
      go2: {
        cen6: "0",
        cen7: "1",
        // cen8: "2",
        cen9: "2",
        cen4: "4",
        cen5: "3",
        cen10: "5",
        cen3: "6",
      },
      anmi1: "",
      anmi2: "",
      anmi3: "",
      ifpc: true,
      opendate:14,
    };
  },
  methods: {
    goto(idx) {
      var id = this.go[idx];
      var newpage = this.$router.resolve({
        path: `/featurepack/${id}`,
      });
      window.open(newpage.href, "_blank");
    },
    setTime(d){
      let month =d.getMonth()+1
      return  String(d.getFullYear())+String(month>9?month:'0'+String(month))+String(d.getDate()>9?d.getDate():'0'+String(d.getDate()))
    },
    // openPdf(d,baseurl){
    //   let D=d.setDate(d.getDate()-7)
    //   D=new Date(D)
    //   let url = baseurl+this.setTime(D)
    //   if(!this.ifpc){
    //       window.location.href="https://www.wenhua.com.cn/popwin/pdfjs/web/viewer.html?file="+url               
    //     }
    //     else{
    //       window.open(url +'.pdf')
    //     }
    // },
    // showPdf(){
    //   let D = new Date()
    //   let baseurl = 'https://ftpc.wenhua.com.cn/files/guide/wh5/%E4%BC%B0%E5%80%BC%E7%BA%BF%E5%BA%94%E7%94%A8%E6%A1%88%E4%BE%8B%E5%8E%86%E5%8F%B2%E4%B8%9A%E7%BB%A9%E6%8A%A5%E5%91%8A'
    //   if(this.opendate>0){
    //     D=D.setDate(D.getDate()-(14-this.opendate))
    //     this.opendate--
    //     D=new Date(D)
    //     let url=baseurl +this.setTime(D)
    //     axios.get(url +'.pdf').then((res)=>{
    //       if(res.status==200){
    //             if(!this.ifpc){
    //               window.location.href="https://www.wenhua.com.cn/popwin/pdfjs/web/viewer.html?file="+url               
    //             }
    //             else{
    //               window.open(url +'.pdf')
    //             }
    //         this.opendate=14
    //       }
    //       else{
    //       }
    //     }).catch((err)=>{
    //         console.log(err)
    //         this.showPdf()
    //     })
    //   }
      
      


    // },


    goto1(idx) {
      var id = this.go1[idx];
      var newpage = this.$router.resolve({
        path: `/featurepack/${id}`,
      });
      window.open(newpage.href, "_blank");
    },
    goto2(idx) {
      var id = this.go2[idx];
      var newpage = this.$router.resolve({
        path: `/invest/${id}`,
      });
      window.open(newpage.href, "_blank");
    },
    show(id) {
      this.cen[id] = true;
    },
    hide(id) {
      this.cen[id] = false;
    },
    mochilun() {
      this.anmi1 = requestAnimationFrame(this.zhuan);
    },
    zhuan() {
      var cl1 = document.getElementsByClassName("dcl")[0];
      var cl2 = document.getElementsByClassName("xcl")[0];
      var cl3 = document.getElementsByClassName("xcl")[1];
      var clli = [cl1, cl2, cl3];

      for (var x = 0; x < clli.length; x++) {
        clli[x].style.transform =
          "rotate(" +
          Number(
            Number(clli[x].style.transform.split("(")[1].split("d")[0]) + 1
          ) +
          "deg)";
      }
      this.anmi1 = requestAnimationFrame(this.zhuan);
    },
    stchilun() {
      window.cancelAnimationFrame(this.anmi1);
    },
    mose() {
      this.anmi2 = requestAnimationFrame(this.tansuo);
    },
    tansuo() {
      var ss = document.getElementsByClassName("sousuo")[0];
      var sl = document.getElementsByClassName("ssli")[0];
      var bb = document.getElementsByClassName("bianb")[0];
      ss.style.transform =
        "rotate(" +
        Number(Number(ss.style.transform.split("(")[1].split("d")[0]) + 2) +
        "deg)";
      sl.style.transform =
        "rotate(" +
        Number(Number(sl.style.transform.split("(")[1].split("d")[0]) - 2) +
        "deg)";
      bb.style.transform =
        "rotateY(" +
        Number(Number(bb.style.transform.split("(")[1].split("d")[0]) + 2) +
        "deg)";
      this.anmi2 = requestAnimationFrame(this.tansuo);
    },
    stse() {
      window.cancelAnimationFrame(this.anmi2);
      this.set2();
    },
    moman() {
      var dh = document.getElementsByClassName("duihao")[0];

      dh.style.width = 0 + "px";

      this.anmi3 = requestAnimationFrame(this.manman);
    },
    manman() {
      var dh = document.getElementsByClassName("duihao")[0];
      var my = document.getElementsByClassName("money")[0];
      if (52 >= Number(dh.style.width.split("px")[0])) {
        dh.style.width = Number(dh.style.width.split("px")[0]) + 1 + "px";
      } else {
        dh.style.width = 0 + "px";
      }
      my.style.transform =
        "rotateY(" +
        Number(Number(my.style.transform.split("(")[1].split("d")[0]) + 2) +
        "deg)";

      this.anmi3 = requestAnimationFrame(this.manman);
    },
    stman() {
      window.cancelAnimationFrame(this.anmi3);
      this.set3();
    },
    showhi(idx) {
      Object.keys(this.cen).forEach((item) => {
        this.cen[item] = false;
      });
      this.cen[idx] = true;
    },

    set1() {
      var cl1 = document.getElementsByClassName("dcl")[0];
      var cl2 = document.getElementsByClassName("xcl")[0];
      var cl3 = document.getElementsByClassName("xcl")[1];
      var clli = [cl1, cl2, cl3];

      for (var x = 0; x < clli.length; x++) {
        clli[x].style.webkitTransform = "rotate(0deg)";
        clli[x].style.MozTransform = "rotate(0deg)";
        clli[x].style.msTransform = "rotate(0deg)";
        clli[x].style.OTransform = "rotate(0deg)";
        clli[x].style.transform = "rotate(0deg)";
      }
    },
    set2() {
      var ss = document.getElementsByClassName("sousuo")[0];
      var sl = document.getElementsByClassName("ssli")[0];
      var bb = document.getElementsByClassName("bianb")[0];
      var s = [ss, sl];
      for (var a = 0; a < s.length; a++) {
        s[a].style.webkitTransform = "rotate(0deg)";
        s[a].style.MozTransform = "rotate(0deg)";
        s[a].style.msTransform = "rotate(0deg)";
        s[a].style.OTransform = "rotate(0deg)";
        s[a].style.transform = "rotate(0deg)";
      }
      bb.style.webkitTransform = "rotateY(0deg)";
      bb.style.MozTransform = "rotateY(0deg)";
      bb.style.msTransform = "rotateY(0deg)";
      bb.style.OTransform = "rotateY(0deg)";
      bb.style.transform = "rotateY(0deg)";
    },
    set3() {
      var dh = document.getElementsByClassName("duihao")[0];
      var my = document.getElementsByClassName("money")[0];
      dh.style.width = 52 + "px";

      my.style.webkitTransform = "rotateY(0deg)";
      my.style.MozTransform = "rotateY(0deg)";
      my.style.msTransform = "rotateY(0deg)";
      my.style.OTransform = "rotateY(0deg)";
      my.style.transform = "rotateY(0deg)";
    },
    detectMob() {
      const toMatch = [
          /Android/i,
          /webOS/i,
          /iPhone/i,
          /iPad/i,
          /iPod/i,
          /BlackBerry/i,
          /Windows Phone/i
      ];
      
      return toMatch.some((toMatchItem) => {
          return navigator.userAgent.match(toMatchItem);
      });
  }
  },
  mounted() {
    // this.set1();
    // this.set2();
    // this.set3();
  },
  created() {
    if (navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i)) {
      this.ifpc = false;
    } else {
      this.ifpc = true;
    }
  },
};
</script>

<style>
.homeht {
  margin-top: 72px;
  background: white;
  position: relative;
}
.homeht .pdf{
  position: absolute;
  left: -145px;
  top: -100px;
  cursor: pointer;
}
.hometop {
  background: url(https://wh-api.wenhua.com.cn/api/WhBanner/GetWhBannerUrl?id=10) no-repeat top;
}
.homecen {
  /* background: url(../../assets/img/lianghua_bg.jpg) no-repeat center; */
}
.homebo {
  background: url(../../assets/img/about_01.png) no-repeat top,
    url(../../assets/img/about_02.jpg) no-repeat bottom;
  height: 263px;
}
.botxt {
  width: 930px;
  margin: 0 auto;
  padding-top: 50px;
  padding-left: 55px;
}
.homeht h5 {
  font-size: 16px;
  color: #5a100d;
  line-height: 30px;
  font-weight: bold;
}
.botxt p {
  line-height: 20px;
  padding: 5px 0 0 0;
  font-size: 14px;
  text-align: justify;
  color: #717171;
}
.centxt {
  width: 1020px;
  margin: 0 auto;
  padding-top: 22px;
}
.centxt h4 {
  font-size: 22px;
  text-align: left;
  color: #5a100d;
  line-height: 35px;
  font-weight: bold;
  margin-left: 40px;
}
.centxt p {
  text-align: left;
  font-size: 14px;
  color: #a57b62;
  margin-left: 40px;
}
.cenhover {
  width: 1020px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  /* padding-top: 31px; */
}
.cenhover .sa {
  width: 285px;
  margin: 11px 28px 11px 27px;
  height: 282px;
  filter: drop-shadow(0 2px 6px #cbb8aa);
  cursor: pointer;
  position: relative;
}
.sa h4 {
  color: #d61d3f;
  font-size: 20px;
  padding-top: 24px;
  text-align: center;
}
.sa p {
  color: #a38c72;
  font-size: 14px;
  padding: 10px 20px;
  text-align: justify;
}
.sa .xiangqing {
  position: absolute;
  left: 20px;
  bottom: 35px;
  color: #a38c72;
  font-size: 14px;
}
.black {
  height: 100%;
  width: 100%;
  background: #c1a695;
  opacity: 0.8;
}
.black h4 {
  color: white;
  font-size: 20px;
  padding-top: 14px;
  text-align: center;
}
.black p {
  text-indent: 2em;
  color: white;
  font-size: 14px;
  padding: 15px;
  text-align: justify;
}
.black div {
  width: 85px;
  border: 1px solid white;
  color: white;
  height: 30px;
  margin: 0 auto;
  line-height: 30px;
  cursor: pointer;
  border-radius: 10px;
  font-size: 14px;
  text-align: center;
}
.black div:hover {
  color: #c1a695;
  background: white;
  border: 1px solid #c1a695;
}
.toptxt {
  padding-top: 450px;
  width: 1020px;
  margin: 0 auto;
}
.topkua {
  width: 255px;
  margin: 35px 40px 20px 40px;
  position: relative;
  cursor: pointer;
  text-align: center;
}
.toptxt h4 {
  font-size: 22px;
  text-align: center;
  color: #5a100d;
  line-height: 35px;
  font-weight: bold;
}
.toptxt p {
  text-align: left;
  font-size: 14px;
  color: #a57b62;
}
.topkua h4 {
  font-size: 22px;
  text-align: center;
  color: #b12a42;
  line-height: 35px;
  font-weight: bold;
  margin: 6px 0;
}
.topkua p {
  text-align: left;
  font-size: 14px;
  color: #705a41;
  margin-top: 5px;
  text-align: justify;
  /* text-indent: -0.5em; */
}
.cc {
  height: 200px;
  position: relative;
  z-index: 22222;
  cursor: pointer;
}
.topkua img {
  /* padding-left: 25px; */
  z-index: 222;
}
.dcl {
  background: url(../../assets/img/chilun-b.png) no-repeat center;
  position: absolute;
  height: 98px;
  width: 98px;
  top: 20px;
  left: 20px;
  z-index: auto;
  transform: rotate(0deg);
  -ms-transform: rotate(0deg); /* IE 9 */
  -moz-transform: rotate(0deg); /* Firefox */
  -webkit-transform: rotate(0deg); /* Safari 和 Chrome */ 
  -o-transform: rotate(0deg); /* Opera */
}
.xcl {
  background: url(../../assets/img/chilun-s.png) no-repeat center;
  position: absolute;
  width: 34px;
  height: 34px;
  transform: rotate(0deg);
  -ms-transform: rotate(0deg); /* IE 9 */
  -moz-transform: rotate(0deg); /* Firefox */
  -webkit-transform: rotate(0deg); /* Safari 和 Chrome */
  -o-transform: rotate(0deg); /* Opera */
}
.bianb {
  position: absolute;
  height: 30px;
  width: 30px;
  top: 70px;
  left: 200px;
  background: url(../../assets/img/bianb-s.png) no-repeat center;
}
.sousuo {
  position: absolute;
  height: 70px;
  width: 70px;
  top: 20px;
  left: 25px;
}
.ssli {
  background: url(../../assets/img/bianb-b.png) no-repeat center;
  height: 56px;
  width: 56px;
  float: right;
  margin-top: 13px;
}
.duihao {
  background: url(../../assets/img/dui.png) no-repeat left;
  height: 52px;
  width: 52px;
  position: absolute;
  top: 30px;
  left: 55px;
}
.money {
  background: url(../../assets/img/qian.png) no-repeat center;
  height: 40px;
  width: 40px;
  position: absolute;
  top: 70px;
  left: 200px;
}
.turnto {
  color: #0000ff;
  line-height: 50px;
  font-size: 14px;
}
.turnto:visited {
  color: #0000ff;
}
.link {
  color: #0000ff;
  font-size: 14px;
}
.link:visited {
  color: #0000ff;
}
</style>